import React, { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  parseCategories,
  calPercentageWithPercent,
  calTotal,
  calcTotalStrikesThrown,
  calcTotalStrikesLanded,
  calcTotalStrikesLandedWithPercent,
} from "../../utils/CategoryUtils";

const CATEGORIES_CIQ = ["TOT", "ARM", "LEG", "GD", "TD", "KD", "SUB"];

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  color: white;
  th {
    padding: 10px;
    text-align: center;
    font-size: 24px;
  }
  td {
    font-size: 24px;
    padding: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    width: 150px;
    border-bottom: 1px solid black;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  text-align: left;
`;

const TR = styled.tr`
  background-color: ${(props) =>
    props.title ? "#343e4e" : props.odd ? "#0f131a" : ""};
  > td:nth-child(2),
  > td:nth-child(4),
  > td:nth-child(6) {
    background-color: ${(props) => (!props.title ? "#932c2c" : "")};
  }
  > td:nth-child(3),
  > td:nth-child(5),
  > td:nth-child(7) {
    background-color: ${(props) => (!props.title ? "#222274" : "")};
  }
`;
export default function TeamStats({ game }) {
  const categories = useMemo(() => {
    return parseCategories(game?.competition?.categories);
  }, [game?.competition?.categories]);

  let period = useMemo(() => {
    let p = [...(game?.live_data?.periods || [])].sort(
      (a, b) => b.number - a.number
    )[0];

    return p;
  }, [game]);

  function calcTotalStrikesThrownLocal({ stats, round }) {
    return calcTotalStrikesThrown({ 
      stats, 
      categories: game?.competition?.categories, 
      round 
    });
  }

  function calcTotalStrikesLandedLocal({ stats, round }) {
    return calcTotalStrikesLandedWithPercent({ 
      stats, 
      categories: game?.competition?.categories, 
      round 
    });
  }

  function calTotalLocal({ stat_1, stat_2, stats, round }) {
    return calTotal({ stat_1, stat_2, stats, round });
  }

  function calPercentageLocal({ missed, landed, stats, round }) {
    return calPercentageWithPercent({ missed, landed, stats, round });
  }

  return (
    game && (
      <Main>
        <Table>
          <thead>
            <tr>
              <TH></TH>
              <TH colSpan={2}>TOTAL FIGHT</TH>
              <TH colSpan={2}>CURRENT ROUND</TH>
              <TH colSpan={2}>LAST ROUND</TH>
            </tr>
          </thead>
          <tbody>
            <TR title={true}>
              <td>TOTAL STRIKES</td>
              <td>{game?.home_fighter?.last_name}</td>
              <td>{game?.away_fighter?.last_name}</td>
              <td>{game?.home_fighter?.last_name}</td>
              <td>{game?.away_fighter?.last_name}</td>
              <td>{game?.home_fighter?.last_name}</td>
              <td>{game?.away_fighter?.last_name}</td>
            </TR>
            <TR>
              <td>THROWN</td>
              <td>
                {calcTotalStrikesThrownLocal({ stats: game?.home_player_stats })}
              </td>
              <td>
                {calcTotalStrikesThrownLocal({ stats: game?.away_player_stats })}
              </td>
              <td>
                {calcTotalStrikesThrownLocal({
                  stats: game?.home_player_stats,
                  round: period?.number,
                })}
              </td>
              <td>
                {calcTotalStrikesThrownLocal({
                  stats: game?.away_player_stats,
                  round: period?.number,
                })}
              </td>
              <td>
                {period?.number > 1 &&
                  calcTotalStrikesThrownLocal({
                    stats: game?.home_player_stats,
                    round: period?.number - 1,
                  })}
              </td>
              <td>
                {period?.number > 1 &&
                  calcTotalStrikesThrownLocal({
                    stats: game?.away_player_stats,
                    round: period?.number - 1,
                  })}
              </td>
            </TR>
            <TR odd={true}>
              <td>LANDED</td>
              <td>
                {calcTotalStrikesLandedLocal({ stats: game?.home_player_stats })}
              </td>
              <td>
                {calcTotalStrikesLandedLocal({ stats: game?.away_player_stats })}
              </td>
              <td>
                {calcTotalStrikesLandedLocal({
                  stats: game?.home_player_stats,
                  round: period?.number,
                })}
              </td>
              <td>
                {calcTotalStrikesLandedLocal({
                  stats: game?.away_player_stats,
                  round: period?.number,
                })}
              </td>
              <td>
                {period?.number > 1 &&
                  calcTotalStrikesLandedLocal({
                    stats: game?.home_player_stats,
                    round: period?.number - 1,
                  })}
              </td>
              <td>
                {period?.number > 1 &&
                  calcTotalStrikesLandedLocal({
                    stats: game?.away_player_stats,
                    round: period?.number - 1,
                  })}
              </td>
            </TR>
            {/* Dynamic category rows */}
            {categories.map((cat, index) => (
              <React.Fragment key={cat.name}>
                <TR title={true}>
                  <td>{cat.name.toUpperCase()}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </TR>
                <TR>
                  <td>THROWN</td>
                  <td>
                    {calTotalLocal({
                      stat_1: cat.landed,
                      stat_2: cat.missed,
                      stats: game?.home_player_stats,
                    })}
                  </td>
                  <td>
                    {calTotalLocal({
                      stat_1: cat.landed,
                      stat_2: cat.missed,
                      stats: game?.away_player_stats,
                    })}
                  </td>
                  <td>
                    {calTotalLocal({
                      stat_1: cat.landed,
                      stat_2: cat.missed,
                      stats: game?.home_player_stats,
                      round: period?.number || 1,
                    })}
                  </td>
                  <td>
                    {calTotalLocal({
                      stat_1: cat.landed,
                      stat_2: cat.missed,
                      stats: game?.away_player_stats,
                      round: period?.number || 1,
                    })}
                  </td>
                  <td>
                    {period?.number > 1 &&
                      calTotalLocal({
                        stat_1: cat.landed,
                        stat_2: cat.missed,
                        stats: game?.home_player_stats,
                        round: period?.number - 1,
                      })}
                  </td>
                  <td>
                    {period?.number > 1 &&
                      calTotalLocal({
                        stat_1: cat.landed,
                        stat_2: cat.missed,
                        stats: game?.away_player_stats,
                        round: period?.number - 1,
                      })}
                  </td>
                </TR>
                <TR odd={true}>
                  <td>LANDED</td>
                  <td>
                    {calPercentageLocal({
                      landed: cat.landed,
                      missed: cat.missed,
                      stats: game?.home_player_stats,
                    })}
                  </td>
                  <td>
                    {calPercentageLocal({
                      landed: cat.landed,
                      missed: cat.missed,
                      stats: game?.away_player_stats,
                    })}
                  </td>
                  <td>
                    {calPercentageLocal({
                      landed: cat.landed,
                      missed: cat.missed,
                      stats: game?.home_player_stats,
                      round: period?.number,
                    })}
                  </td>
                  <td>
                    {calPercentageLocal({
                      landed: cat.landed,
                      missed: cat.missed,
                      stats: game?.away_player_stats,
                      round: period?.number,
                    })}
                  </td>
                  <td>
                    {period?.number > 1 &&
                      calPercentageLocal({
                        landed: cat.landed,
                        missed: cat.missed,
                        stats: game?.home_player_stats,
                        round: period?.number - 1,
                      })}
                  </td>
                  <td>
                    {period?.number > 1 &&
                      calPercentageLocal({
                        landed: cat.landed,
                        missed: cat.missed,
                        stats: game?.away_player_stats,
                        round: period?.number - 1,
                      })}
                  </td>
                </TR>
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </Main>
    )
  );
}
